var map = {
	"./1.gif": "bsKc",
	"./1.mp4": "URub",
	"./1.png": "LOA1",
	"./10.png": "rhId",
	"./11.png": "RKxq",
	"./12.png": "FUCY",
	"./13.png": "A34k",
	"./2.gif": "SLvF",
	"./2.png": "NKGv",
	"./3.gif": "gsrU",
	"./3.png": "LHqX",
	"./4.gif": "InA1",
	"./4.png": "+TIe",
	"./5.png": "2Pfm",
	"./6.png": "bvch",
	"./7.png": "y4L6",
	"./8.png": "I6fH",
	"./9.png": "E2RZ",
	"./Frame 5.png": "PFzH",
	"./Frame 52 - 副本.png": "xsmJ",
	"./Frame 52.png": "+CxX",
	"./Group 354.png": "7ELq",
	"./Group 355.png": "84h2",
	"./Group 356.png": "Jkxe",
	"./Group357.png": "KeH8",
	"./Image.png": "lZ/A",
	"./Mail.png": "hDxA",
	"./MaskGroup.png": "jKLd",
	"./Partner 2.png": "i/jz",
	"./Partner.png": "AUwx",
	"./Play.png": "+vy0",
	"./Rectangle.png": "Sw8L",
	"./Rectanglew.png": "nNnX",
	"./SmartPlatform1.png": "zC6W",
	"./SmartPlatform2.png": "ukPb",
	"./SmartPlatform3.png": "xVkG",
	"./SmartPlatform4.png": "61WW",
	"./SmartPlatform5.png": "ZHqx",
	"./SmartPlatform6.png": "yfxh",
	"./SmartPlatform7.png": "pJNp",
	"./URL.png": "4odu",
	"./VR.png": "EOJg",
	"./about1.png": "Cqk5",
	"./about2.png": "LZ2M",
	"./about3.png": "kb9U",
	"./about4.png": "zyr8",
	"./about5.png": "6fpb",
	"./about_img.png": "NUQr",
	"./background1.png": "uFI5",
	"./background2.png": "YJiL",
	"./background3.png": "X7pB",
	"./background33.png": "/dit",
	"./background4.png": "6Tbh",
	"./background5.png": "/jRS",
	"./background7.png": "UmLC",
	"./backgroundHome1.png": "yIu9",
	"./backgroundHome2.png": "0mH7",
	"./backgroundHome3.png": "P+FG",
	"./banner1.png": "1MxG",
	"./banner2.jpg": "7/Ek",
	"./banner_1.jpg": "dEG5",
	"./banner_2.jpg": "S29U",
	"./bg1.png": "RepZ",
	"./but.png": "Z4cp",
	"./circle.png": "mDJx",
	"./computer.png": "GY21",
	"./contact_us_bg.jpg": "pnq8",
	"./from.png": "SKFY",
	"./img1.png": "M3eK",
	"./logo.png": "dLd/",
	"./logo_black.png": "q3zs",
	"./logo_hp.png": "bhvW",
	"./logo_kk.png": "blpe",
	"./logo_toyota.png": "QbkR",
	"./logo_white.png": "s9k0",
	"./phone.png": "5ng9",
	"./position.png": "jzOa",
	"./progress bar.png": "n4Le",
	"./progress bar2.png": "2TUS",
	"./qq.png": "mTCC",
	"./service1.jpg": "PwBN",
	"./service2.jpg": "FJQj",
	"./service3.jpg": "R742",
	"./service4.jpg": "UW51",
	"./skill.png": "3HfK",
	"./tabs1.png": "X8do",
	"./tabs2.png": "ifvM",
	"./tabs3.png": "bvMg",
	"./tabs4.png": "u2ci",
	"./tel.png": "81Ru",
	"./twitter.png": "ZKaF",
	"./virtualReality1.png": "JGND",
	"./virtualReality2.png": "uxYX",
	"./virtualReality3.png": "WJxV",
	"./virtualReality4.png": "5cBA",
	"./virtualReality5.png": "5Ybl",
	"./virtualReality6.png": "6Ve5",
	"./weibo.png": "5WfB",
	"./weixin.png": "q0uv",
	"./yinhao.png": "TIoG",
	"./危化品全周期管理系统.png": "7iB4",
	"./危废处置_x264.mp4": "Vk1h",
	"./安全教育网站-2.png": "G0/3",
	"./安全教育网站.png": "cyCg",
	"./实验室安全检查.png": "yUIp",
	"./实验室安全检查2.png": "vVtE",
	"./实验室安全考试系统.png": "vHw6",
	"./实验室综合管理系统.png": "3I4K",
	"./文法知识产权_x264.mp4": "JX7H",
	"./湖北中医药大学_x264.mp4": "8Gss",
	"./纺织大学_x264.mp4": "PE6y",
	"./能动-高压容弹_x264.mp4": "3K/D",
	"./课程资源建设平台.png": "BBqf",
	"./课程资源建设平台学生端 2.png": "LO6u",
	"./课程资源建设平台学生端.png": "Wk6J",
	"./课程资源建设平台学生端1.png": "etl9",
	"./车规级芯片录屏_x264.mp4": "llDK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 13